export default __webpack_public_path__ + "static/media/2.53483a4c.jpg";